import React from 'react';

import { Container } from './styles';

import { CancelProps } from './interface';

const Cancel: React.FC<CancelProps> = ({ children, ...props }) => {
  return (
    <Container {...props}>
      {' '}
      <>{children}</>
    </Container>
  );
};

export default Cancel;
